// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"479":"2e5ea091","787":"02338e13"}[chunkId] + ".chunk.js";
};